
import Link from '@/components/compat/Link';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { painelSurfaceClass } from '@/components/painel/painel-styles';
import { cn } from '@/lib/utils';
import { useCms } from '@/components/painel/cms/cms-context';
import { painelInputClass } from '@/components/painel/cms/painel-form';
import { usePainelText } from '@/components/painel/painel-texts-context';

export function PainelHomepageEditorPage() {
  const pageText = usePainelText('pagina_homepage');
  const { site, setSite, hydrated } = useCms();
  const { hero } = site;

  const patchHero = (patch: typeof hero) => {
    setSite({ ...site, hero: patch });
  };

  return (
    <div className="space-y-8">
      <div>
        <Button
          variant="ghost"
          asChild
          className="mb-2 -ml-2 rounded-xl text-slate-300 hover:bg-white/10 hover:text-white"
        >
          <Link href="/painel/paginas">
            <ArrowLeft className="mr-2 h-4 w-4" />
            Páginas
          </Link>
        </Button>
        <h1 className="font-poppins text-2xl font-bold tracking-tight text-white md:text-3xl">
          {pageText.title}
        </h1>
        <p className="mt-1 font-inter text-sm text-slate-400">{pageText.description}</p>
      </div>

      <div
        className={cn(
          painelSurfaceClass,
          'space-y-5 p-6 md:p-8',
          !hydrated && 'opacity-70'
        )}
      >
        <div className="grid gap-2">
          <Label htmlFor="hero-title" className="text-blue-100/90">
            Título do hero
          </Label>
          <input
            id="hero-title"
            value={hero.title}
            onChange={(e) => patchHero({ ...hero, title: e.target.value })}
            className={painelInputClass}
          />
        </div>
        <div className="grid gap-2">
          <Label htmlFor="hero-desc" className="text-blue-100/90">
            Descrição
          </Label>
          <textarea
            id="hero-desc"
            value={hero.description}
            onChange={(e) => patchHero({ ...hero, description: e.target.value })}
            className={cn(painelInputClass, 'min-h-[100px] resize-y py-2')}
          />
        </div>
        <div className="grid gap-4 sm:grid-cols-2">
          <div className="grid gap-2">
            <Label htmlFor="btn1-text" className="text-blue-100/90">
              Texto botão 1
            </Label>
            <input
              id="btn1-text"
              value={hero.primaryButtonLabel}
              onChange={(e) => patchHero({ ...hero, primaryButtonLabel: e.target.value })}
              className={painelInputClass}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="btn1-q" className="text-blue-100/90">
              Pesquisa ao clicar (botão 1)
            </Label>
            <input
              id="btn1-q"
              value={hero.primarySearchQuery}
              onChange={(e) => patchHero({ ...hero, primarySearchQuery: e.target.value })}
              className={painelInputClass}
              placeholder="Ex.: conta"
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="btn2-text" className="text-blue-100/90">
              Texto botão 2
            </Label>
            <input
              id="btn2-text"
              value={hero.secondaryButtonLabel}
              onChange={(e) => patchHero({ ...hero, secondaryButtonLabel: e.target.value })}
              className={painelInputClass}
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="btn2-q" className="text-blue-100/90">
              Pesquisa ao clicar (botão 2)
            </Label>
            <input
              id="btn2-q"
              value={hero.secondarySearchQuery}
              onChange={(e) => patchHero({ ...hero, secondarySearchQuery: e.target.value })}
              className={painelInputClass}
              placeholder="Ex.: senha"
            />
          </div>
        </div>

        <p className="font-inter text-xs text-slate-400/80">
          As alterações são gravadas automaticamente ao editar.
        </p>
      </div>
    </div>
  );
}
